import { useEffect, useState } from "react";
import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";
import { useToast } from "../ToastContext";
import "./NoteHistoryPanel.css";

const BASE = `${u}/note`;

export default function NoteHistoryPanel({ noteId, onRestored }) {
  const toast = useToast();
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoring, setRestoring] = useState(null);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!noteId) return;
    setLoading(true);
    apiFetch(`${BASE}/${noteId}/history`)
      .then(r => r.ok ? r.json() : [])
      .then(d => { setVersions(Array.isArray(d) ? d : []); })
      .finally(() => setLoading(false));
  }, [noteId]);

  const handleRestore = async (versionId) => {
    if (!window.confirm("Restore this version? The current content will be saved as a new version.")) return;
    setRestoring(versionId);
    const res = await apiFetch(`${BASE}/${noteId}/history/${versionId}/restore`, { method: "POST" });
    setRestoring(null);
    if (res.ok) {
      toast("Version restored successfully.", "success");
      onRestored?.();
    } else {
      toast("Restore failed.", "error");
    }
  };

  if (loading) return <div className="nhp-loading">Loading history…</div>;
  if (versions.length === 0) return <div className="nhp-empty">No version history yet. Versions are saved on each edit.</div>;

  return (
    <div className="nhp-panel">
      <div className="nhp-title">Version History ({versions.length})</div>
      <div className="nhp-list">
        {versions.map((v, i) => (
          <div key={v.id} className="nhp-version">
            <div className="nhp-version-header" onClick={() => setExpanded(p => p === v.id ? null : v.id)}>
              <div className="nhp-version-meta">
                <span className="nhp-version-num">v{v.versionNumber}</span>
                <span className="nhp-version-date">{v.createdAt?.replace("T"," ").slice(0, 16)}</span>
                {i === 0 && <span className="nhp-version-badge">Latest save</span>}
              </div>
              <button
                className="nhp-restore-btn"
                onClick={e => { e.stopPropagation(); handleRestore(v.id); }}
                disabled={restoring === v.id}
              >
                {restoring === v.id ? "…" : "Restore"}
              </button>
            </div>
            {expanded === v.id && (
              <div className="nhp-version-preview">
                <strong>{v.title}</strong>
                <div className="nhp-version-content"
                  dangerouslySetInnerHTML={{ __html: v.content || "<em>Empty</em>" }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
